import Upgrade from '@view/components/Upgrade';

const Addons = () => {
  return <Upgrade />;
};

export default Addons;
